import type Player from 'video.js/dist/types/player';

export interface VideoAdapter {
  getCurrentTime: () => number;
  getDuration: () => number;
  getPlaybackRate: () => number;
  on: (event: string, handler: () => void) => void;
  off: (event: string, handler: () => void) => void;
  dispose?: () => void;
}

// Video.js adapter
export class VideoJsAdapter implements VideoAdapter {
  constructor(private readonly player: Player) {}

  getCurrentTime = () => this.player.currentTime() ?? 0;
  getDuration = () => this.player.duration() ?? 0;
  getPlaybackRate = () => this.player.playbackRate() ?? 1;

  on = (event: string, handler: () => void) => {
    this.player.on(event, handler);
  };

  off = (event: string, handler: () => void) => {
    this.player.off(event, handler);
  };

  dispose = () => {
    // Video.js handles its own disposal
  };
}

// Native HTML5 video adapter
export class NativeVideoAdapter implements VideoAdapter {
  constructor(private readonly video: HTMLVideoElement) {}

  getCurrentTime = () => this.video.currentTime ?? 0;
  getDuration = () => this.video.duration ?? 0;
  getPlaybackRate = () => this.video.playbackRate ?? 1;

  on = (event: string, handler: () => void) => {
    this.video.addEventListener(event, handler);
  };

  off = (event: string, handler: () => void) => {
    this.video.removeEventListener(event, handler);
  };

  dispose = () => {
    // Cleanup if needed
  };
}
